
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NodeFormMixin from '../forms/NodeFormMixin';
import ActivityTypeMapping from 'utils/activityTypeMapping';
import * as BusinessObjectTypeMapping from 'utils/businessObjectTypeMapping';

@Component({
  name: 'ActivitySummary',
})
export default class ActivitySummary extends NodeFormMixin {
  activityTypeMapping = ActivityTypeMapping;

  businessObjectTypeMapping = BusinessObjectTypeMapping;

  get delay() {
    if (!this.data.action.date) {
      return null;
    }
    let duration = +this.data.action.date.minutes || 0;
    duration += +this.data.action.date.hours * 60 || 0;
    duration += +this.data.action.date.days * 60 * 24 || 0;
    duration += +this.data.action.date.weeks * 60 * 24 * 7 || 0;
    duration += +this.data.action.date.months * 60 * 24 * 7 * 4 || 0;
    return (this.$moment as any).duration(duration, 'minutes').humanize();
  }

  get duration() {
    return (this.$moment as any).duration(this.data.action.duration ?? 0, 'minutes').humanize();
  }
}
